export const CARRINHO_SET_DADOS = 'CARRINHO_SET_DADOS';
export const CARRINHO_SET_CLEAR = 'CARRINHO_SET_CLEAR';